$(document).ready(function () {
    // More Services
    var pagination = $('.js-more-services-pagination');
    var slider = $('.js-more-services-slider');

    var homePageSlider = $('.js-home-page-services-slider');

    slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        pagination.text(i + '/' + (slick.$dots[0].children.length));
    });

    homePageSlider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        pagination.text(i + '/' + (slick.$dots[0].children.length));
    });

    slider.slick({
        arrows: true,
        dots: true,
        centerMode: true,
        centerPadding: '250px',
        slidesToShow: 2,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.theme_url + '/static/images/carousel-arrow-left-green.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.theme_url + '/static/images/carousel-arrow-right-green.svg" alt="next arrow"></div>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    centerMode: true,
                    centerPadding: '100px',
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 900,
                settings: {
                    centerMode: true,
                    centerPadding: '100px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 700,
                settings: {
                    centerMode: false,
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 500,
                settings: {
                    centerMode: false,
                    slidesToShow: 1
                }
            }
        ]
    });

    homePageSlider.slick({
        arrows: true,
        dots: true,
        centerMode: true,
        centerPadding: '250px',
        slidesToShow: 1,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.theme_url + '/static/images/carousel-arrow-left-green.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.theme_url + '/static/images/carousel-arrow-right-green.svg" alt="next arrow"></div>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    centerMode: true,
                    centerPadding: '100px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 900,
                settings: {
                    centerMode: true,
                    centerPadding: '100px',
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 700,
                settings: {
                    centerMode: false,
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 500,
                settings: {
                    centerMode: false,
                    slidesToShow: 1
                }
            }
        ]
    });
});